import { render, staticRenderFns } from "./VendorAccountSidebar.vue?vue&type=template&id=32193d60"
import script from "./VendorAccountSidebar.vue?vue&type=script&lang=js"
export * from "./VendorAccountSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports